var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"cta-content-dosing"}},[_vm._m(0),_c('CTABanner',{attrs:{"onlyBanner":true,"bannerData":{ bannerText: 'see safety', href: '/safety' }}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"p-5"})])
}]

export { render, staticRenderFns }